import axios from 'axios';

export default (cognitoUserId) =>
  axios.get(`${process.env.VUE_APP_API_ENDPOINT}/persons/persons-by-cognito-id/${cognitoUserId}`);
